import AssetsIcon from "./AssetsIcon";

const assetKinds = [
  "/L - REAL ESTATE ACTIVITIES/012-house.svg",
  "/L - REAL ESTATE ACTIVITIES/041-placeholder.svg",
  "/L - REAL ESTATE ACTIVITIES/007-blueprint.svg",
  "/L - REAL ESTATE ACTIVITIES/028-lift.svg",
  "/L - REAL ESTATE ACTIVITIES/010-auction.svg",
  "/L - REAL ESTATE ACTIVITIES/016-measurement.svg",
  "/L - REAL ESTATE ACTIVITIES/042-cheque.svg",
  "/L - REAL ESTATE ACTIVITIES/045-fence.svg",
  "/L - REAL ESTATE ACTIVITIES/034-renovation.svg",
  "/L - REAL ESTATE ACTIVITIES/037-discount.svg",
  "/L - REAL ESTATE ACTIVITIES/008-house rental.svg",
  "/L - REAL ESTATE ACTIVITIES/027-dream.svg",
  "/L - REAL ESTATE ACTIVITIES/036-sale.svg",
  "/L - REAL ESTATE ACTIVITIES/029-eco house.svg",
  "/L - REAL ESTATE ACTIVITIES/003-agent.svg",
  "/L - REAL ESTATE ACTIVITIES/043-billboard.svg",
  "/L - REAL ESTATE ACTIVITIES/025-bank.svg",
  "/L - REAL ESTATE ACTIVITIES/032-factory.svg",
  "/L - REAL ESTATE ACTIVITIES/004-contract.svg",
  "/L - REAL ESTATE ACTIVITIES/040-smart house.svg",
  "/L - REAL ESTATE ACTIVITIES/009-sale.svg",
  "/L - REAL ESTATE ACTIVITIES/022-stats.svg",
  "/L - REAL ESTATE ACTIVITIES/020-sold.svg",
  "/L - REAL ESTATE ACTIVITIES/014-garage.svg",
  "/L - REAL ESTATE ACTIVITIES/019-accommodation.svg",
  "/L - REAL ESTATE ACTIVITIES/046-shopping mall.svg",
  "/L - REAL ESTATE ACTIVITIES/044-mailbox.svg",
  "/L - REAL ESTATE ACTIVITIES/001-apartment.svg",
  "/L - REAL ESTATE ACTIVITIES/023-warehouse.svg",
  "/L - REAL ESTATE ACTIVITIES/015-app.svg",
  "/L - REAL ESTATE ACTIVITIES/005-building.svg",
  "/L - REAL ESTATE ACTIVITIES/047-living room.svg",
  "/L - REAL ESTATE ACTIVITIES/039-rating.svg",
  "/L - REAL ESTATE ACTIVITIES/006-search.svg",
  "/L - REAL ESTATE ACTIVITIES/021-mansion.svg",
  "/L - REAL ESTATE ACTIVITIES/013-solar house.svg",
  "/L - REAL ESTATE ACTIVITIES/026-shop.svg",
  "/L - REAL ESTATE ACTIVITIES/038-website.svg",
  "/L - REAL ESTATE ACTIVITIES/002-house.svg",
  "/L - REAL ESTATE ACTIVITIES/035-loan.svg",
  "/L - REAL ESTATE ACTIVITIES/033-document.svg",
  "/L - REAL ESTATE ACTIVITIES/018-lock.svg",
  "/L - REAL ESTATE ACTIVITIES/024-protected.svg",
  "/L - REAL ESTATE ACTIVITIES/030-yurt.svg",
  "/L - REAL ESTATE ACTIVITIES/011-deal.svg",
  "/L - REAL ESTATE ACTIVITIES/031-direction.svg",
  "/L - REAL ESTATE ACTIVITIES/017-chat.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/062-processor.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/025-spirit level.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/028-thermal imaging.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/009-voltmeter.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/049-drilling.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/044-warehouse.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/078-computer.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/046-field controller.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/053-bridge.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/057-checklist.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/051-eco energy.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/034-drone.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/007-desktop computer.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/089-food.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/085-crane truck.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/072-bioengineering.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/071-dna strand.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/045-tape measure.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/033-laser level.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/068-power supply.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/060-document.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/096-aeroplane.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/075-performance.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/011-education.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/091-computer.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/097-lathe.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/070-tablet.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/076-team.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/027-gas.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/047-blueprint.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/010-hazard sign.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/038-electrical engineer.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/065-clamp.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/083-building.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/017-innovation.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/005-measuring tool.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/063-cog.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/001-cogs.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/099-team.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/012-calculator.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/029-measurement.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/037-pliers.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/018-compass.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/077-machine.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/050-theodolite.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/013-tape measure.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/043-welding mask.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/087-saw blade.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/081-drill.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/079-test.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/041-book.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/061-aerospace.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/015-robot.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/022-blueprint.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/093-drilling.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/094-medical.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/016-vector.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/026-robot arm.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/058-robotic arm.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/064-training.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/080-blueprint.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/020-hook.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/023-laptop.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/039-smartphone.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/056-eco.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/004-processor.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/035-3d printer.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/048-measuring tool.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/067-puzzle.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/019-technology.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/084-factory.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/073-engineer.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/036-location.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/021-pressure gauge.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/030-cogs.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/055-nanotech.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/052-house.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/040-internet.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/008-spanner.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/006-blueprint.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/100-forklift.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/059-solution.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/002-engineer.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/003-engineer.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/082-farm.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/095-pendulum.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/092-oil.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/069-boat.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/042-transistor.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/024-ball bearing.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/014-electrical.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/031-screwdriver.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/066-topographic.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/032-circuit board.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/088-nuclear.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/090-Multimeter.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/086-propeller.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/098-building.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/054-brain.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Engineering/074-building.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Biochemistry/biology.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Biochemistry/chemistry.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Biochemistry/analysis.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Biochemistry/radiation.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Biochemistry/molecular.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Biochemistry/dropper.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Biochemistry/radiactive.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Biochemistry/physics.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Biochemistry/formula.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Biochemistry/volumetric.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Biochemistry/syringe.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Biochemistry/gas-mask.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Biochemistry/biohazard.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Biochemistry/dangerous.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Biochemistry/cloning.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Biochemistry/reproduction.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Biochemistry/flask.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Biochemistry/dna.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Biochemistry/cell-division.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Biochemistry/microscope.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Biochemistry/bacteria.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Biochemistry/blood-test.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Biochemistry/flask-1.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Biochemistry/flask-3.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Biochemistry/atomic.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Biochemistry/flasks.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Biochemistry/laboratory.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Biochemistry/petri-dish.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Biochemistry/biology-1.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Biochemistry/flask-2.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/011-virtual assistant.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/039-expert.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/029-add task.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/013-add task.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/049-solving problem.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/030-contractor.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/036-repair.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/038-organization.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/044-online doctor.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/031-budgeting.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/045-interpreter.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/026-professional services.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/048-consultant.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/012-advocate.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/033-survey.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/041-talent.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/024-management.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/002-virtual assistant.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/014-ask the expert.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/016-presentation.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/020-project management.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/040-professional.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/009-managment.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/037-invoice.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/047-tech support.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/028-advocate.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/005-ask the expert.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/042-competency.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/010-tutor.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/004-add task.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/046-team.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/001-professional services.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/017-designer.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/032-reliable.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/015-therapy.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/008-data analyst.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/018-working hours.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/043-tax consultant.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/025-human resource.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/034-landscaper.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/027-virtual assistant.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/050-document.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/023-engineer.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/003-advocate.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/021-accounting.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/035-web development.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/019-content marketing.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/006-doctor.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/007-financial planning.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Professional/022-logistics.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Scientific/008-report.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Scientific/014-blackboard.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Scientific/021-science.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Scientific/004-report-1.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Scientific/001-science-2.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Scientific/013-lamp.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Scientific/024-test-tube-2.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Scientific/011-physics.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Scientific/005-test-tube-8.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Scientific/020-bacteria.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Scientific/015-test-tube-5.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Scientific/023-whiteboard.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Scientific/025-briefcase.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Scientific/017-scientist.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Scientific/009-scientist-1.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Scientific/003-test-tube-9.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Scientific/022-folder.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Scientific/029-test-tube-1.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Scientific/019-test-tube-3.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Scientific/016-test-tube-4.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Scientific/010-file.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Scientific/006-test-tube-7.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Scientific/018-science-1.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Scientific/027-einstein.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Scientific/030-test-tube.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Scientific/002-test-tube-10.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Scientific/007-microscope.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Scientific/028-apple.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Scientific/026-plasma-ball.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Scientific/012-test-tube-6.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/049-dynamic site activation.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/006-anonymous.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/022-filtering.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/001-software.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/041-database management.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/010-authentication.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/043-dav.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/042-multimedia.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/033-server.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/028-automatically.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/047-certificate.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/009-integrated.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/011-modular.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/012-extension.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/048-dynamic ip address.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/020-certificate.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/030-users.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/044-deployment.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/039-window.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/027-initialization.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/008-authentication.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/023-authorization.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/018-process.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/017-performance.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/035-cpu.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/Computer-based/011-printer.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/Computer-based/006-smartphone.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/Computer-based/026-network.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/Computer-based/025-network-1.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/Computer-based/019-fingerprint.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/Computer-based/010-monitor.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/Computer-based/024-network-2.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/Computer-based/013-video-call.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/Computer-based/016-keyboard.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/Computer-based/018-router.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/Computer-based/012-mouse.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/Computer-based/014-microphone.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/Computer-based/005-malware.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/Computer-based/007-computer-1.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/Computer-based/027-computer.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/Computer-based/002-webcam.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/Computer-based/017-harddisk.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/Computer-based/022-website.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/Computer-based/009-projector.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/Computer-based/003-tablet.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/Computer-based/020-folder-1.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/Computer-based/023-laptop.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/Computer-based/004-pendrive.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/Computer-based/028-folder.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/Computer-based/029-shield.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/Computer-based/008-ram-memory.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/Computer-based/001-laptop-2.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/Computer-based/015-laptop-1.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/Computer-based/021-database.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/024-uninstall.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/036-performance.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/003-features.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/019-access control.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/013-added.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/015-integration.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/014-removed.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/016-installed.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/004-higher.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/007-authentication.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/040-web server.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/026-administration.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/037-troubleshooting.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/045-reboot.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/025-targeted.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/046-administration.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/021-security control.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/029-deployment.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/032-splash page.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/034-ssl.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/002-web search.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/005-security.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/031-server.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/038-logging.svg",
  "/M - PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES/Technical/050-security.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/027-water.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/008-h2o.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/032-watering.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Recycling/022-reduce.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Recycling/009-Environmental.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Recycling/020-material.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Recycling/025-trash bin.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Recycling/013-glass.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Recycling/008-electronic.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Recycling/026-trash.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Recycling/024-waste.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Recycling/019-plastic bottle.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Recycling/017-paper.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Recycling/030-zero waste.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Recycling/004-cardboard.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Recycling/018-paper recycle.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Recycling/023-reuse.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Recycling/028-oil.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Recycling/015-no plastic bags.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Recycling/014-medical.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Recycling/001-conservation.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Recycling/007-ecology.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Recycling/005-waste.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Recycling/002-battery.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Recycling/010-garbage bag.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Recycling/012-garbage truck.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Recycling/027-management.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Recycling/016-garbage.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Recycling/021-recycling.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Recycling/029-sorting.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Recycling/006-friendly.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Recycling/003-waste.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Recycling/011-treatment.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/018-fire.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/015-nuclear.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/002-gas mask.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/017-pollution.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/035-nose.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/001-barrel.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/007-broken.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/050-gas leak.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/009-cigarrete.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/045-radioactive.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/040-skull.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/032-exhaust pipe.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/039-medical mask.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/044-waste water.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/020-waste water.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/010-global warming.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/008-trash truck.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/033-rubbish.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/023-oil pump.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/047-incense therapy.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/019-medical mask.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/024-radioactive.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/016-cannon.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/014-lungs.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/028-nuclear.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/030-waste water.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/004-factory.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/048-CO2 cloud.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/022-battery.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/036-waste water.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/012-deforestation.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/003-biohazard sign.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/027-acid rain.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/037-gas mask.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/046-nuclear.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/005-plant.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/006-nuclear.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/041-trash.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/043-Recycled Plastic Bag.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/026-waste water.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/049-factory.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/013-nuclear power.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/011-volcano.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/031-energy.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/038-nuclear energy.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/029-soil.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/042-leak.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/025-bacteria.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/034-factory.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/Polution/021-methane.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/003-drink water.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/006-faucet.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/013-rainy.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/030-water tower.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/017-sprinkler.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/024-water meter.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/025-water pipe.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/016-shower.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/004-drinking water.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/005-droplet.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/012-rain.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/022-water drop.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/001-clean water.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/031-water.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/010-human body.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/007-fish.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/026-water pump.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/019-wave.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/011-wave.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/015-save water.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/028-water earth.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/023-water energy.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/009-hosepipe.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/018-tank truck.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/002-dam.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/014-reuse water.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/020-washing clothes.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/029-water tank.svg",
  "/E - WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES/021-water bottle.svg",
  "/B - MINING AND QUARRYING/013-coal factory.svg",
  "/B - MINING AND QUARRYING/011-combustible.svg",
  "/B - MINING AND QUARRYING/012-excavator.svg",
  "/B - MINING AND QUARRYING/015-mining cart.svg",
  "/B - MINING AND QUARRYING/004-conveyor system.svg",
  "/B - MINING AND QUARRYING/019-explosive.svg",
  "/B - MINING AND QUARRYING/017-safety vest.svg",
  "/B - MINING AND QUARRYING/005-tools.svg",
  "/B - MINING AND QUARRYING/014-coaling station.svg",
  "/B - MINING AND QUARRYING/003-hard hat.svg",
  "/B - MINING AND QUARRYING/006-grader.svg",
  "/B - MINING AND QUARRYING/001-miner.svg",
  "/B - MINING AND QUARRYING/010-dragline excavator.svg",
  "/B - MINING AND QUARRYING/009-mining industry.svg",
  "/B - MINING AND QUARRYING/007-pickaxe.svg",
  "/B - MINING AND QUARRYING/008-bucket wheel excavator.svg",
  "/B - MINING AND QUARRYING/002-bulldozer.svg",
  "/B - MINING AND QUARRYING/016-quarry.svg",
  "/B - MINING AND QUARRYING/020-dump truck.svg",
  "/B - MINING AND QUARRYING/018-coaling station.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/024-customer satisfaction.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/012-help.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/014-live chat.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/015-call center.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/017-about.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/007-error 404.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/004-robot.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/009-call center.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/008-data.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/028-recruitment.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/049-productivity.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/004-test.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/020-dossier.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/033-question.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/005-expense.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/010-website.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/037-Versatile.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/044-selection.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/038-choice.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/040-qualification.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/030-ability.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/048-teamwork.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/006-employee.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/023-connection.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/043-best employee.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/013-curriculum vitae.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/026-candidate.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/003-businessman.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/031-human mind.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/007-human resources.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/012-web browser.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/034-intelligence.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/036-resume and cv.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/029-add user.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/018-personal data.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/024-profit.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/045-time management.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/042-turnover.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/039-job search.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/046-promotion.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/014-administrator.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/047-skill.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/002-legal document.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/017-Cooperation.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/001-resources.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/035-Appraisal.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/021-job rotation.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/025-motivation.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/050-creative.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/011-evaluation.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/041-time is money.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/015-unexperience.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/027-manager.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/022-flowchart.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/019-curriculum.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/009-contract.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/032-vacancy.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/Admin and HR/016-characteristic.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/018-mobile service.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/003-customer support.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/005-technical Support.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/013-support.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/011-information.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/019-mobile information.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/001-email.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/022-help desk.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/016-information.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/008-quide.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/023-operator.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/021-reputation.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/020-call support.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/006-location.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/002-help.svg",
  "/N - ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES/010-help.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/023-apartment.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/010-house key.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/049-apartment.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/003-payment.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/048-contract.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/022-rental.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/038-faucet.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/014-property.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/002-renovation.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/040-rental.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/025-moving.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/004-accomodation.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/036-property.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/029-real estate.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/042-property.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/012-property.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/044-paint.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/016-moving.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/001-property.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/024-insurance.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/030-payment.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/015-armchair.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/039-loan.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/035-warehouse.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/020-broker.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/050-kitchen.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/026-moving.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/006-for rent.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/021-rental.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/032-apartment.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/047-fence.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/033-key.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/045-house repair.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/043-moving.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/017-discount.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/019-real estate agent.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/013-rental.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/028-moving.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/031-insurance.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/046-shower.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/005-location.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/050-delivery man.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/003-fast food.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/032-menu.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/015-food delivery.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/041-food delivery.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/035-take away.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/023-fast food.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/048-delivery man.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/014-delivery man.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/031-list.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/022-24 hours.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/047-restaurant.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/042-online order.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/011-online order.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/045-meat.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/040-online payment.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/009-milk box.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/027-fast delivery.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/036-sushi.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/005-review.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/049-delivery man.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/017-scooter.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/043-bill.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/008-pizzas.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/024-payment.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/006-delivery man.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/002-review.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/037-drone delivery.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/044-take away.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/026-delivery man.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/038-bakery.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/018-food truck.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/010-bakery.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/013-feedback.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/007-coffee.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/020-food delivery.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/025-front door.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/021-food delivery.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/034-pin.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/019-delivery truck.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/030-food delivery.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/046-noodles.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/029-fast delivery.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/039-online payment.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/033-food container.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/012-online order.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/028-online order.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/004-hamburger.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/016-payment.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Food & Food Delivery/001-groceries.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/002-tea.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/019-sausage.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/030-kebab.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/023-pizza-slice.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/043-chicken-leg.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/005-cola-1.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/031-delivery.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/047-menu.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/050-french-fries.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/017-croissant.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/010-burger.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/035-taco.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/048-hot-dog.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/014-sauces.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/028-rice.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/007-burger-1.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/020-fried-egg.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/006-burger-2.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/009-coffee.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/037-soda.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/042-beer.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/018-cheese.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/033-waiter-1.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/044-pitcher.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/029-package.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/026-ice-cream.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/049-breakfast.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/015-hot-dog-1.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/011-ice-cream-1.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/016-chicken-leg-1.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/024-chef-hat.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/022-serving-dish.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/040-coffee-cup.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/001-popcorn.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/041-waffle.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/034-waiter.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/027-donut.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/012-cola.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/039-fork.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/004-tomato-sauce.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/036-chips.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/025-meat.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/003-chinese-food.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/013-milkshake.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/046-noodles.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/038-take-away.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/032-food-truck.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/045-coffee-machine.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/008-fried-potatoes.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/Fast Food/021-fried-chicken.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/037-property.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/034-agent.svg",
  "/I - ACCOMMODATION AND FOOD SERVICE ACTIVITIES/009-agreement.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/034-work from home.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/036-calendar.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/009-chatting.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/029-work from home.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/027-work from home.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/033-stay at home.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/019-break.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/005-work from home.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/040-video record.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/024-network.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/012-conference.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/022-profile.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/014-work from home.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/013-work from home.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/020-work from home.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/011-web cam.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/018-work from home.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/023-sign in.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/007-work from home.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/035-network.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/003-work from home.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/034-industrialization.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/050-quality standard.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/006-industrial process.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/048-manufacturing process.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/008-break even point.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/031-rapid prototyping.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/049-rpa.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/021-industrial.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/016-precision.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/018-customization.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/003-efficiency.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/042-manufacturing.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/036-process optimization.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/030-precision.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/033-lean manufacturing.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/035-capital expenditure.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/015-quality control.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/014-product cycle.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/037-continuous improvement.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/002-assembly line.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/013-productivity.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/025-production line.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/017-interchangeability.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/007-replication.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/047-capacity.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/041-high volume.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/010-industry 4.0.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/019-productivity.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/011-mass production.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/001-mass production.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/023-specialization.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/024-production.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/028-efficiency.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/039-mass production.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/046-efficiency.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/043-industrial revolution.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/032-supply chain.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/044-product weight.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/004-standardization.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/005-automation.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/045-material handling.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/027-just in time.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/038-product inspection.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/012-job opportunities.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/020-market.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/040-factory.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/029-time allocation.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/022-emerging.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/009-factory.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/Goods Production/026-raw material.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/039-video chat.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/026-video record.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/008-social network.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/032-work from home.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/031-work from home.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/015-work from home.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/002-hotel.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/021-conference.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/001-cafe.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/038-work from home.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/030-work from home.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/010-facetime.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/004-home office.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/037-work from home.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/006-stay at home.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/016-freelance.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/017-work from home.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/028-work from home.svg",
  "/T - ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; UNDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE/025-work place.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/001-green house.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/017-cactus.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/018-garden.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/053-shovel.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/034-water well.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/033-weather.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/004-farmer.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/044-footwear.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/059-bench.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/014-clipboard.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/045-fountain.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/027-flower.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/022-plants.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/057-watering can.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/047-plant pot.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Organic Farming/011-harvest.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Organic Farming/004-harvest-2.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Organic Farming/017-coffee-cup.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Organic Farming/010-groceries.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Organic Farming/029-orange.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Organic Farming/021-fertilizer.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Organic Farming/018-diploma.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Organic Farming/030-organic-1.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Organic Farming/035-bacteria.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Organic Farming/008-harvest-1.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Organic Farming/019-nutrition.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Organic Farming/001-grass.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Organic Farming/006-wheat.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Organic Farming/024-insecticide.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Organic Farming/005-tea.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Organic Farming/014-windmill.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Organic Farming/013-fruit.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Organic Farming/025-vegetables.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Organic Farming/028-carrot.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Organic Farming/022-farm.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Organic Farming/020-organic-2.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Organic Farming/003-pesticide.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Organic Farming/009-milk.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Organic Farming/036-tomato.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Organic Farming/015-eggs.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Organic Farming/016-milky.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Organic Farming/027-salad.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Organic Farming/023-sprout.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Organic Farming/002-salad-1.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Organic Farming/012-market.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Organic Farming/007-dinner.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Organic Farming/026-farmer-2.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Organic Farming/032-farmer.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Organic Farming/034-chemiscal.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Organic Farming/031-farmer-1.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Organic Farming/033-organic.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/005-butterflies.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/048-ladder.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/037-scarecrow.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/024-plants.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/032-gardening.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/043-suit.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/028-street lamp.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/050-Sickle.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/041-apron.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/012-windmill.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/035-rain.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/015-bonsai.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/007-bee.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/030-brush.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/031-eggs.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/022-farming.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/025-monitoring-1.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/007-crops.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/021-monitoring.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/033-milking.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/039-farm-1.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/013-wind.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/026-hydroponic.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/034-pesticide.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/012-watering.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/015-smart-farm-2.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/008-greenhouse.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/009-silo.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/027-hay.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/020-planting.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/018-watering-sprayer.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/036-chicken.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/010-smart-farm-1.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/032-egg.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/038-genetic.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/016-quality-test.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/011-bug-repellent.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/005-farmer.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/004-tractor.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/040-harvest.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/019-conveyor.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/002-smart-farm.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/024-indoor-plants.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/006-solar-energy.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/003-sprinkler.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/023-lawn.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/035-crops-2.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/037-milk.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/029-poultry.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/028-crops-1.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/017-smart-farm-3.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/014-vertical-farming.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/Smart Farming/001-farm.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/002-lawn mower.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/010-pesticide.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/006-gnome.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/040-sand bucket.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/003-farmer.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/008-no insects.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/054-water tap.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/025-smart farming.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/039-wheelbarrow.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/038-bird house.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/056-gate.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/009-spray.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/058-fence.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/042-gloves.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/023-gazebo.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/055-water hose.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/011-calendar.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/026-sprinklers.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/031-bamboo.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/029-grass.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/049-scissors.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/046-hanging pot.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/019-shovel.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/020-seeding.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/060-tractor.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/036-fertilizer.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/030-germination.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/021-sprout.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/052-axe.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/013-open book.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/016-apple tree.svg",
  "/A - AGRICULTURE, FORESTRY AND FISHING/051-saw.svg",
  "/J - INFORMATION AND COMMUNICATION/027-call.svg",
  "/J - INFORMATION AND COMMUNICATION/014-video-camera.svg",
  "/J - INFORMATION AND COMMUNICATION/033-search.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/001-send-mail.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/027-email-4.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/036-calendar.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/040-profile.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/018-telephone.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/048-email.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/015-mail.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/050-phone.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/035-website.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/042-phone-1.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/045-call.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/006-home-message.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/016-send-1.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/010-mail-1.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/037-address.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/041-text.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/002-message.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/030-email-3.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/023-contact.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/007-mail-2.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/047-location.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/019-video-chat.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/004-mail-3.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/028-phone-2.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/012-mouse.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/009-phone-3.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/021-mailbox.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/020-template.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/005-telephone-2.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/029-write-letter.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/043-email-1.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/014-online-question.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/026-email-5.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/032-time-call.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/046-chat-1.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/022-send.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/034-schedule.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/033-telephone-book.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/025-world.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/049-chat.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/011-web.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/031-time-call-1.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/003-mail-4.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/039-home.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/024-globe.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/008-mobile-phone.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/038-email-2.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/017-telephone-1.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/013-sending-call.svg",
  "/J - INFORMATION AND COMMUNICATION/Get in Touch/044-call-1.svg",
  "/J - INFORMATION AND COMMUNICATION/009-helicopter.svg",
  "/J - INFORMATION AND COMMUNICATION/012-world-1.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/008-no-wifi.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/004-phone-4.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/006-phone-3.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/001-bluetooth-1.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/010-cloud.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/042-bluetooth.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/011-contact-book.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/021-storage.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/024-email-3.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/038-phone.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/050-message.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/034-telephone-1.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/028-phone-2.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/048-browsers.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/023-email-4.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/039-love.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/007-satellite.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/029-mail-1.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/045-contact.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/036-telephone.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/031-mail.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/040-computer.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/014-chat-bubble.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/030-envelopes.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/049-wifi-connection.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/018-mailbox.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/035-phone-1.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/043-smartwatch.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/047-laptop.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/027-email.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/002-phone-6.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/041-servers.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/013-chat-bubble-1.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/026-email-1.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/037-money.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/019-computer-1.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/012-microphone.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/003-phone-5.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/044-message-1.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/033-send-mail.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/017-chat-1.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/022-support.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/032-chat.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/005-support-1.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/009-router.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/046-tablet.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/016-checklist.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/020-connection.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/015-phone-call.svg",
  "/J - INFORMATION AND COMMUNICATION/Communications/025-email-2.svg",
  "/J - INFORMATION AND COMMUNICATION/044-newspaper-1.svg",
  "/J - INFORMATION AND COMMUNICATION/016-laptop.svg",
  "/J - INFORMATION AND COMMUNICATION/025-microphone-1.svg",
  "/J - INFORMATION AND COMMUNICATION/048-television.svg",
  "/J - INFORMATION AND COMMUNICATION/026-clock.svg",
  "/J - INFORMATION AND COMMUNICATION/003-cassette.svg",
  "/J - INFORMATION AND COMMUNICATION/018-pin.svg",
  "/J - INFORMATION AND COMMUNICATION/010-24-hours.svg",
  "/J - INFORMATION AND COMMUNICATION/032-pencil.svg",
  "/J - INFORMATION AND COMMUNICATION/005-smartphone.svg",
  "/J - INFORMATION AND COMMUNICATION/004-microphone.svg",
  "/J - INFORMATION AND COMMUNICATION/040-telephone.svg",
  "/J - INFORMATION AND COMMUNICATION/041-headphones.svg",
  "/J - INFORMATION AND COMMUNICATION/028-eye.svg",
  "/J - INFORMATION AND COMMUNICATION/023-news.svg",
  "/J - INFORMATION AND COMMUNICATION/006-notes.svg",
  "/J - INFORMATION AND COMMUNICATION/030-projector.svg",
  "/J - INFORMATION AND COMMUNICATION/001-world.svg",
  "/J - INFORMATION AND COMMUNICATION/050-speaker.svg",
  "/J - INFORMATION AND COMMUNICATION/007-press-card.svg",
  "/J - INFORMATION AND COMMUNICATION/017-smartphone-1.svg",
  "/J - INFORMATION AND COMMUNICATION/042-newspaper.svg",
  "/J - INFORMATION AND COMMUNICATION/022-messages.svg",
  "/J - INFORMATION AND COMMUNICATION/049-news-1.svg",
  "/J - INFORMATION AND COMMUNICATION/034-antenna.svg",
  "/J - INFORMATION AND COMMUNICATION/008-car.svg",
  "/J - INFORMATION AND COMMUNICATION/037-office.svg",
  "/J - INFORMATION AND COMMUNICATION/021-satellite-1.svg",
  "/J - INFORMATION AND COMMUNICATION/035-live-news.svg",
  "/J - INFORMATION AND COMMUNICATION/029-form.svg",
  "/J - INFORMATION AND COMMUNICATION/045-magnifier.svg",
  "/J - INFORMATION AND COMMUNICATION/020-paper-plane.svg",
  "/J - INFORMATION AND COMMUNICATION/043-video-player.svg",
  "/J - INFORMATION AND COMMUNICATION/039-hourglass.svg",
  "/J - INFORMATION AND COMMUNICATION/038-statistics.svg",
  "/J - INFORMATION AND COMMUNICATION/036-radio.svg",
  "/J - INFORMATION AND COMMUNICATION/031-podcast.svg",
  "/J - INFORMATION AND COMMUNICATION/002-video.svg",
  "/J - INFORMATION AND COMMUNICATION/019-rec.svg",
  "/J - INFORMATION AND COMMUNICATION/046-tablet.svg",
  "/J - INFORMATION AND COMMUNICATION/024-dictaphone.svg",
  "/J - INFORMATION AND COMMUNICATION/011-newsletter.svg",
  "/J - INFORMATION AND COMMUNICATION/013-satellite.svg",
  "/J - INFORMATION AND COMMUNICATION/047-newspaper-2.svg",
  "/J - INFORMATION AND COMMUNICATION/015-camera.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Medicine/022-medicament.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Medicine/027-dentistry.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Medicine/020-navigator.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Medicine/010-donor.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Medicine/019-toothpaste.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Medicine/026-mobile app.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Medicine/016-protection.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Medicine/011-medication.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Medicine/028-crutches.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Medicine/030-wheelchair.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Medicine/015-shield.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Medicine/008-doctor.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Medicine/004-hospital bed.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Medicine/007-medicament.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Medicine/002-ribbon.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Medicine/006-first aid kit.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Medicine/005-medication.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Medicine/025-Hygeia.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Medicine/017-volunteer.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Medicine/013-emergency.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Medicine/021-caduceus.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Medicine/024-teamwork.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Medicine/001-auto.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Medicine/009-doctor.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Medicine/029-disabled people.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Medicine/023-receipt.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Medicine/012-emergency call.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Medicine/014-mobile app.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Medicine/018-clinic.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Medicine/003-vaccine.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Social Care/020-medicine.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Social Care/013-Solidarity.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Social Care/005-health services.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Social Care/011-advocacy.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Social Care/010-assistance.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Social Care/022-family.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Social Care/021-insurance.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Social Care/024-blood donation.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Social Care/025-charity.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Social Care/001-social care.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Social Care/004-care.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Social Care/007-empathy.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Social Care/017-welfare.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Social Care/014-unity.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Social Care/016-respect.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Social Care/003-health support.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Social Care/008-compassion.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Social Care/002-community.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Social Care/015-healing.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Social Care/006-wellness.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Social Care/018-kindness.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Social Care/012-connection.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Social Care/019-medical check.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Social Care/009-inclusion.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Social Care/023-donation.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/022-heart.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/042-syringe.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/003-blood test.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/038-stay home.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/023-hospital.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/017-clipboard.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/014-face protection.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/044-sick.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/004-cold.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/032-fever.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/043-thermometer.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/031-temperature.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/027-laboratory.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/041-handwash.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/021-healthcare.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/050-world.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/011-drug.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/002-virus.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/005-coronavirus.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/045-fever.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/020-healthcare.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/039-bill.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/040-thermometer.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/016-file.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/006-cough.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/025-handwash.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/046-sick.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/047-tissue.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/037-quarantine.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/009-doctor.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/018-shake hands.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/019-handwash.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/035-protection.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/015-mask.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/026-infected lungs.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/028-file.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/008-long distance.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/049-work from home.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/024-cleaning spray.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/007-cough.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/048-shake hands.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/013-dont touch.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/029-lung.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/001-ambulance.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/036-hand glove.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/030-mobile phone.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/034-coronavirus.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/033-protection.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/010-doctor.svg",
  "/Q - HUMAN HEALTH AND SOCIAL WORK ACTIVITIES/Healthcare and Medical/012-drugs.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/008-engine oil.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/019-steering wheel.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/023-chassis.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/010-cog.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/007-car lift.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/003-spark plug.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/014-pulley.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/005-belt.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/017-toolbox.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/004-wiper.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/015-brake disc.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/016-speedometer.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2B/025-vision.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2B/012-mobile shopping.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2B/005-efficiency.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2B/016-product management.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2B/011-market research.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2B/004-distribution.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2B/009-internet.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2B/008-insurance.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2B/022-time management.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2B/024-user engagement.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2B/023-transaction.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2B/014-price list.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2B/019-risk study.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2B/001-collaboration.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2B/010-location.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2B/021-shopping.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2B/018-review.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2B/007-goods.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2B/015-product.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2B/013-online store.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2B/003-copywriting.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2B/017-retailers.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2B/002-conversion.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2B/020-sales funnel.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2B/006-feedback.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/006-engine.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/018-car repair.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/021-repair.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/025-shock absorber.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/024-tire.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/009-Rim.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/011-exhaust pipe.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Motoring and Incidents/001-two.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Motoring and Incidents/003-car.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Motoring and Incidents/020-machine.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Motoring and Incidents/016-car.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Motoring and Incidents/009-car.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Motoring and Incidents/019-burning.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Motoring and Incidents/012-car.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Motoring and Incidents/013-burning.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Motoring and Incidents/005-car.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Motoring and Incidents/006-car.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Motoring and Incidents/015-burning.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Motoring and Incidents/018-car.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Motoring and Incidents/014-car.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Motoring and Incidents/008-car.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Motoring and Incidents/017-bag.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Motoring and Incidents/004-car.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Motoring and Incidents/007-car.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Motoring and Incidents/010-burning.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Motoring and Incidents/011-phone.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Motoring and Incidents/002-car.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/022-accumulator.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/001-pistons.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/013-radiator.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/089-car.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/018-exhaust.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/073-wheel.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/070-wheel.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/067-wheel.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/024-wheel.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/078-computer.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/086-tool.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/079-windscreen.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/061-calendar.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/076-crash.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/053-air conditioning.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/047-pedals.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/040-car repair.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/003-wheel.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/036-tyre.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/071-spoiler.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/054-wheel.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/030-mirror.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/050-certificate.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/026-car key.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/032-engine.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/077-belt.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/087-truck.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/084-bottle.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/015-brakes.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/098-seat.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/049-search.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/090-basket.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/029-piston.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/057-car.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/038-bulb.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/041-drive belt.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/051-car.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/034-windshield.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/016-car.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/062-bike.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/055-wheels.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/080-car.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/058-radio.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/063-engine.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/045-wheel.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/023-car.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/095-document.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/006-gear.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/065-truck.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/059-air filter.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/011-gearstick.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/004-wheels.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/008-spark plug.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/044-headlight.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/001-wheel.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/014-tyre.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/088-key.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/028-car.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/012-engine.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/025-funnel.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/043-hook.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/009-can.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/005-car.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/083-screen.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/056-car.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/031-hat.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/020-car door.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/096-breaks.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/099-gear.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/002-man.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/019-gps.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/075-fuse.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/042-book.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/082-garage.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/085-car door.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/060-car.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/072-mirror.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/039-toolbox.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/046-handbrake.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/033-pump.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/027-jack.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/052-car.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/010-suspension.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/066-alternator.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/021-turbo.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/097-car.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/035-device.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/081-wheel.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/074-Bumper.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/091-laptop.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/092-van.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/022-seat.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/093-headlight.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/068-clip.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/048-spring.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/064-van.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/013-radiator.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/017-tool.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/069-car.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/094-stool.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/037-gear.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/100-computer.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/Mechanic & Repairs/007-battery.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/012-horn.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/014-direct marketing.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/020-market research.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/024-product innovation.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/042-business.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/049-purchasing.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/045-statistics.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/047-Successful.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/041-fast delivery.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/001-broker.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/013-sales.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/007-brand.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/026-supply chain management.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/036-project management.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/021-retailer.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/022-price list.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/016-Efficient.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/034-shopping.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/046-mobile shopping.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/005-disadvantage.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/038-transportation.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/017-relationship.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/002-store.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/033-mobile shopping.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/003-wholesaler.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/027-product.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/006-product.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/011-self growth.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/023-transaction.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/010-product.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/025-goods.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/028-economy.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/032-cyber security.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/029-devaluation.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/043-service.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/019-distributor.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/012-social media marketing.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/035-b2c.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/048-employee.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/039-customer feedback.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/040-internet.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/004-selling.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/050-best product.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/018-loyal customer.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/030-quality.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/009-customer.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/015-advantage.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/008-risk study.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/037-company.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/031-data security.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/B2C/044-mobile payment.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/020-car seats.svg",
  "/G - WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES AND MOTORCYCLES/002-car repair.svg",
  "/MISC/Buildings/family-house-facade.svg",
  "/MISC/Buildings/closed-barn.svg",
  "/MISC/Buildings/apartment-house-1.svg",
  "/MISC/Buildings/big-glamourous-house.svg",
  "/MISC/Buildings/industrial-zone.svg",
  "/MISC/Buildings/fire-station.svg",
  "/MISC/Buildings/catholic-church.svg",
  "/MISC/Buildings/apartment-house-2.svg",
  "/MISC/Buildings/small-wind-mill.svg",
  "/MISC/Buildings/office-building.svg",
  "/MISC/Buildings/water-tower.svg",
  "/MISC/Buildings/country-family-house.svg",
  "/MISC/Buildings/small-chapel.svg",
  "/MISC/Buildings/english-cottage.svg",
  "/MISC/Buildings/big-skyscrapers.svg",
  "/MISC/Buildings/theater-facade.svg",
  "/MISC/Buildings/school-building.svg",
  "/MISC/Buildings/hospital-with-cross.svg",
  "/MISC/Buildings/mosque-facade.svg",
  "/MISC/Buildings/synagogue.svg",
  "/MISC/Buildings/industrial-plant.svg",
  "/MISC/Buildings/castle-with-three-towers.svg",
  "/MISC/Buildings/skyscraper-with-antennas.svg",
  "/MISC/Buildings/skyscraper-building.svg",
  "/MISC/Buildings/2-store-building.svg",
  "/MISC/Buildings/nuclear-plant-chimneys.svg",
  "/MISC/Buildings/russian-orthodox-church.svg",
  "/MISC/Buildings/museum-facade.svg",
  "/MISC/Buildings/closed-garage.svg",
  "/MISC/Buildings/expensive-house.svg",
  "/MISC/Buildings/rural-house.svg",
  "/MISC/Buildings/apartment-building.svg",
  "/MISC/Buildings/street-shop.svg",
  "/MISC/Buildings/loft-building.svg",
  "/MISC/Buildings/flat-plant.svg",
  "/MISC/Buildings/little-store.svg",
  "/MISC/Buildings/apartment-house.svg",
  "/MISC/Buildings/4-store-building.svg",
  "/MISC/Buildings/lighthouse-construction.svg",
  "/MISC/Buildings/big-office-building.svg",
  "/MISC/Buildings/police-station-facade.svg",
  "/MISC/Buildings/loft-with-windows.svg",
  "/MISC/Buildings/country-house.svg",
  "/MISC/Buildings/house-with-hearth.svg",
  "/MISC/Buildings/duplex-house.svg",
  "/MISC/Buildings/supermaket.svg",
  "/MISC/Buildings/office-store.svg",
  "/MISC/Buildings/tv-tower.svg",
  "/MISC/Buildings/house-with-garage.svg",
  "/MISC/Buildings/big-castle.svg",
  "/MISC/Vehicles/car-with-spare-tire.svg",
  "/MISC/Vehicles/transportation-truck.svg",
  "/MISC/Vehicles/flying-airliner.svg",
  "/MISC/Vehicles/trolleybus-facing-right.svg",
  "/MISC/Vehicles/railroad-car.svg",
  "/MISC/Vehicles/industrial-excavator.svg",
  "/MISC/Vehicles/cargo-ship.svg",
  "/MISC/Vehicles/tractor-facing-right.svg",
  "/MISC/Vehicles/truck-with-freight.svg",
  "/MISC/Vehicles/kick-scooter.svg",
  "/MISC/Vehicles/vintage-zeppelin.svg",
  "/MISC/Vehicles/balloon-flying.svg",
  "/MISC/Vehicles/vintage-scooter.svg",
  "/MISC/Vehicles/crane-truck.svg",
  "/MISC/Vehicles/tourist-bus.svg",
  "/MISC/Vehicles/old-style-bicycle.svg",
  "/MISC/Vehicles/submarine.svg",
  "/MISC/Vehicles/fast-train.svg",
  "/MISC/Vehicles/big-cargo-truck.svg",
  "/MISC/Vehicles/excavator-facing-right.svg",
  "/MISC/Vehicles/racing-motorbike.svg",
  "/MISC/Vehicles/minibus-trip.svg",
  "/MISC/Vehicles/sail-boat-navigating.svg",
  "/MISC/Vehicles/beach-watercraft.svg",
  "/MISC/Vehicles/sport-utility-vehicle.svg",
  "/MISC/Vehicles/long-car.svg",
  "/MISC/Vehicles/segway.svg",
  "/MISC/Vehicles/public-tram.svg",
  "/MISC/Vehicles/flying-helicopter.svg",
  "/MISC/Vehicles/luxury-yacht.svg",
  "/MISC/Vehicles/sedan.svg",
  "/MISC/Crisis Management/013-evaluation.svg",
  "/MISC/Crisis Management/007-public relation.svg",
  "/MISC/Crisis Management/015-plan.svg",
  "/MISC/Crisis Management/006-debt.svg",
  "/MISC/Crisis Management/039-restructure.svg",
  "/MISC/Crisis Management/016-reputation loss.svg",
  "/MISC/Crisis Management/047-interruption.svg",
  "/MISC/Crisis Management/011-understand.svg",
  "/MISC/Crisis Management/024-Natural disaster.svg",
  "/MISC/Crisis Management/038-presentation.svg",
  "/MISC/Crisis Management/046-discussion.svg",
  "/MISC/Crisis Management/028-performance.svg",
  "/MISC/Crisis Management/022-immediate.svg",
  "/MISC/Crisis Management/044-adaptation.svg",
  "/MISC/Crisis Management/020-timeline.svg",
  "/MISC/Crisis Management/018-goal.svg",
  "/MISC/Crisis Management/017-recovery.svg",
  "/MISC/Crisis Management/010-implement.svg",
  "/MISC/Crisis Management/009-lost.svg",
  "/MISC/Crisis Management/034-productivity.svg",
  "/MISC/Crisis Management/035-stress.svg",
  "/MISC/Crisis Management/029-asset management.svg",
  "/MISC/Crisis Management/025-to do list.svg",
  "/MISC/Crisis Management/030-priority.svg",
  "/MISC/Crisis Management/019-strategy.svg",
  "/MISC/Crisis Management/026-workflow.svg",
  "/MISC/Crisis Management/048-agenda.svg",
  "/MISC/Crisis Management/012-solution.svg",
  "/MISC/Crisis Management/008-crisis management.svg",
  "/MISC/Crisis Management/049-crisis.svg",
  "/MISC/Crisis Management/031-document.svg",
  "/MISC/Crisis Management/027-risk.svg",
  "/MISC/Crisis Management/033-monitored.svg",
  "/MISC/Crisis Management/014-investment.svg",
  "/MISC/Crisis Management/042-time management.svg",
  "/MISC/Crisis Management/005-anticipation.svg",
  "/MISC/Crisis Management/032-declare.svg",
  "/MISC/Crisis Management/001-improvement.svg",
  "/MISC/Crisis Management/050-hrm.svg",
  "/MISC/Crisis Management/040-deadline.svg",
  "/MISC/Crisis Management/045-recession.svg",
  "/MISC/Crisis Management/023-investment.svg",
  "/MISC/Crisis Management/037-decision making.svg",
  "/MISC/Crisis Management/004-hiring.svg",
  "/MISC/Crisis Management/002-awareness.svg",
  "/MISC/Crisis Management/021-pros and cons.svg",
  "/MISC/Crisis Management/043-expansion.svg",
  "/MISC/Crisis Management/003-multitasking.svg",
  "/MISC/Crisis Management/041-protection.svg",
  "/MISC/Crisis Management/036-identify.svg",
  "/MISC/IT and Computing/039-vga.svg",
  "/MISC/IT and Computing/019-networking.svg",
  "/MISC/IT and Computing/038-domain.svg",
  "/MISC/IT and Computing/Coding/012-cloud computing.svg",
  "/MISC/IT and Computing/Coding/031-mobile app.svg",
  "/MISC/IT and Computing/Coding/042-ssl.svg",
  "/MISC/IT and Computing/Coding/035-responsive design.svg",
  "/MISC/IT and Computing/Coding/020-file.svg",
  "/MISC/IT and Computing/Coding/002-ads.svg",
  "/MISC/IT and Computing/Coding/037-security system.svg",
  "/MISC/IT and Computing/Coding/008-binary code.svg",
  "/MISC/IT and Computing/Coding/027-landing.svg",
  "/MISC/IT and Computing/Coding/003-algorithm.svg",
  "/MISC/IT and Computing/Coding/048-website.svg",
  "/MISC/IT and Computing/Coding/005-application.svg",
  "/MISC/IT and Computing/Coding/036-search.svg",
  "/MISC/IT and Computing/Coding/034-pop up.svg",
  "/MISC/IT and Computing/Coding/044-tablet.svg",
  "/MISC/IT and Computing/Coding/021-file protection.svg",
  "/MISC/IT and Computing/Coding/043-structure.svg",
  "/MISC/IT and Computing/Coding/032-mockup design.svg",
  "/MISC/IT and Computing/Coding/025-javascript.svg",
  "/MISC/IT and Computing/Coding/022-file transfer.svg",
  "/MISC/IT and Computing/Coding/046-web design.svg",
  "/MISC/IT and Computing/Coding/009-bug.svg",
  "/MISC/IT and Computing/Coding/010-chatbot.svg",
  "/MISC/IT and Computing/Coding/017-data.svg",
  "/MISC/IT and Computing/Coding/041-software development.svg",
  "/MISC/IT and Computing/Coding/038-setting.svg",
  "/MISC/IT and Computing/Coding/014-computer.svg",
  "/MISC/IT and Computing/Coding/001-ab testing.svg",
  "/MISC/IT and Computing/Coding/019-error.svg",
  "/MISC/IT and Computing/Coding/007-big data.svg",
  "/MISC/IT and Computing/Coding/029-loading.svg",
  "/MISC/IT and Computing/Coding/024-html.svg",
  "/MISC/IT and Computing/Coding/050-worldwide.svg",
  "/MISC/IT and Computing/Coding/030-log in.svg",
  "/MISC/IT and Computing/Coding/016-css.svg",
  "/MISC/IT and Computing/Coding/011-checklist.svg",
  "/MISC/IT and Computing/Coding/047-web maintenance.svg",
  "/MISC/IT and Computing/Coding/004-api.svg",
  "/MISC/IT and Computing/Coding/015-content.svg",
  "/MISC/IT and Computing/Coding/033-php.svg",
  "/MISC/IT and Computing/Coding/039-smartphone.svg",
  "/MISC/IT and Computing/Coding/018-developer.svg",
  "/MISC/IT and Computing/Coding/049-workflow.svg",
  "/MISC/IT and Computing/Coding/023-gps.svg",
  "/MISC/IT and Computing/Coding/013-coding.svg",
  "/MISC/IT and Computing/Coding/026-keyboard.svg",
  "/MISC/IT and Computing/Coding/045-user.svg",
  "/MISC/IT and Computing/Coding/040-software.svg",
  "/MISC/IT and Computing/Coding/028-layout.svg",
  "/MISC/IT and Computing/Coding/006-app development.svg",
  "/MISC/IT and Computing/045-news.svg",
  "/MISC/IT and Computing/021-tablet.svg",
  "/MISC/IT and Computing/048-projector.svg",
  "/MISC/IT and Computing/009-email.svg",
  "/MISC/IT and Computing/005-wifi connection.svg",
  "/MISC/IT and Computing/028-cloud network.svg",
  "/MISC/IT and Computing/036-schedule.svg",
  "/MISC/IT and Computing/014-usb flash drive.svg",
  "/MISC/IT and Computing/042-cpu tower.svg",
  "/MISC/IT and Computing/006-video conference.svg",
  "/MISC/IT and Computing/046-menu.svg",
  "/MISC/IT and Computing/033-mouse.svg",
  "/MISC/IT and Computing/025-cd.svg",
  "/MISC/IT and Computing/032-computer.svg",
  "/MISC/IT and Computing/Networks/058-folder-3.svg",
  "/MISC/IT and Computing/Networks/056-ethernet-1.svg",
  "/MISC/IT and Computing/Networks/073-file-sharing-2.svg",
  "/MISC/IT and Computing/Networks/064-network-11.svg",
  "/MISC/IT and Computing/Networks/019-folder-11.svg",
  "/MISC/IT and Computing/Networks/033-laptop-3.svg",
  "/MISC/IT and Computing/Networks/010-cloud-computing-2.svg",
  "/MISC/IT and Computing/Networks/091-share.svg",
  "/MISC/IT and Computing/Networks/081-sharing-2.svg",
  "/MISC/IT and Computing/Networks/054-firewall.svg",
  "/MISC/IT and Computing/Networks/061-transfer.svg",
  "/MISC/IT and Computing/Networks/013-monitor-6.svg",
  "/MISC/IT and Computing/Networks/009-transfer-2.svg",
  "/MISC/IT and Computing/Networks/062-file-3.svg",
  "/MISC/IT and Computing/Networks/065-router-1.svg",
  "/MISC/IT and Computing/Networks/083-wireless.svg",
  "/MISC/IT and Computing/Networks/068-internet.svg",
  "/MISC/IT and Computing/Networks/031-internet-1.svg",
  "/MISC/IT and Computing/Networks/045-download.svg",
  "/MISC/IT and Computing/Networks/072-folder.svg",
  "/MISC/IT and Computing/Networks/036-monitor-1.svg",
  "/MISC/IT and Computing/Networks/055-file-4.svg",
  "/MISC/IT and Computing/Networks/040-transfer-1.svg",
  "/MISC/IT and Computing/Networks/039-folder-6.svg",
  "/MISC/IT and Computing/Networks/095-laptop.svg",
  "/MISC/IT and Computing/Networks/051-folder-5.svg",
  "/MISC/IT and Computing/Networks/071-folder-1.svg",
  "/MISC/IT and Computing/Networks/049-file-6.svg",
  "/MISC/IT and Computing/Networks/026-laptop-6.svg",
  "/MISC/IT and Computing/Networks/066-folder-2.svg",
  "/MISC/IT and Computing/Networks/077-network-9.svg",
  "/MISC/IT and Computing/Networks/063-server-3.svg",
  "/MISC/IT and Computing/Networks/046-network-13.svg",
  "/MISC/IT and Computing/Networks/078-network-8.svg",
  "/MISC/IT and Computing/Networks/092-server-1.svg",
  "/MISC/IT and Computing/Networks/022-file-7.svg",
  "/MISC/IT and Computing/Networks/053-firewall-1.svg",
  "/MISC/IT and Computing/Networks/042-laptop-2.svg",
  "/MISC/IT and Computing/Networks/052-folder-4.svg",
  "/MISC/IT and Computing/Networks/021-network-14.svg",
  "/MISC/IT and Computing/Networks/050-file-5.svg",
  "/MISC/IT and Computing/Networks/014-server-6.svg",
  "/MISC/IT and Computing/Networks/084-network-5.svg",
  "/MISC/IT and Computing/Networks/074-laptop-1.svg",
  "/MISC/IT and Computing/Networks/093-router.svg",
  "/MISC/IT and Computing/Networks/008-ethernet-2.svg",
  "/MISC/IT and Computing/Networks/099-file-sharing.svg",
  "/MISC/IT and Computing/Networks/002-cloud-computing-4.svg",
  "/MISC/IT and Computing/Networks/025-folder-9.svg",
  "/MISC/IT and Computing/Networks/098-printing.svg",
  "/MISC/IT and Computing/Networks/079-network-7.svg",
  "/MISC/IT and Computing/Networks/096-network.svg",
  "/MISC/IT and Computing/Networks/004-tablet.svg",
  "/MISC/IT and Computing/Networks/097-server.svg",
  "/MISC/IT and Computing/Networks/037-folder-8.svg",
  "/MISC/IT and Computing/Networks/094-desktop.svg",
  "/MISC/IT and Computing/Networks/088-sharing-1.svg",
  "/MISC/IT and Computing/Networks/069-earth-grid.svg",
  "/MISC/IT and Computing/Networks/060-monitor.svg",
  "/MISC/IT and Computing/Networks/011-cloud-computing-1.svg",
  "/MISC/IT and Computing/Networks/080-network-6.svg",
  "/MISC/IT and Computing/Networks/089-sharing.svg",
  "/MISC/IT and Computing/Networks/012-smartphone.svg",
  "/MISC/IT and Computing/Networks/032-monitor-3.svg",
  "/MISC/IT and Computing/Networks/034-files.svg",
  "/MISC/IT and Computing/Networks/044-download-1.svg",
  "/MISC/IT and Computing/Networks/028-laptop-4.svg",
  "/MISC/IT and Computing/Networks/087-network-2.svg",
  "/MISC/IT and Computing/Networks/085-network-4.svg",
  "/MISC/IT and Computing/Networks/090-network-1.svg",
  "/MISC/IT and Computing/Networks/007-ethernet-3.svg",
  "/MISC/IT and Computing/Networks/030-monitor-4.svg",
  "/MISC/IT and Computing/Networks/023-folder-10.svg",
  "/MISC/IT and Computing/Networks/082-file-1.svg",
  "/MISC/IT and Computing/Networks/075-network-10.svg",
  "/MISC/IT and Computing/Networks/024-monitor-5.svg",
  "/MISC/IT and Computing/Networks/015-server-5.svg",
  "/MISC/IT and Computing/Networks/100-file.svg",
  "/MISC/IT and Computing/Networks/016-server-4.svg",
  "/MISC/IT and Computing/Networks/003-drive.svg",
  "/MISC/IT and Computing/Networks/047-network-12.svg",
  "/MISC/IT and Computing/Networks/035-monitor-2.svg",
  "/MISC/IT and Computing/Networks/018-shield.svg",
  "/MISC/IT and Computing/Networks/086-network-3.svg",
  "/MISC/IT and Computing/Networks/038-folder-7.svg",
  "/MISC/IT and Computing/Networks/041-wifi-1.svg",
  "/MISC/IT and Computing/Networks/067-server-2.svg",
  "/MISC/IT and Computing/Networks/059-share-1.svg",
  "/MISC/IT and Computing/Networks/076-file-sharing-1.svg",
  "/MISC/IT and Computing/Networks/027-laptop-5.svg",
  "/MISC/IT and Computing/Networks/005-cloud-computing-3.svg",
  "/MISC/IT and Computing/Networks/043-download-2.svg",
  "/MISC/IT and Computing/Networks/006-ethernet-4.svg",
  "/MISC/IT and Computing/Networks/001-broadcast.svg",
  "/MISC/IT and Computing/Networks/020-network-15.svg",
  "/MISC/IT and Computing/Networks/057-ethernet.svg",
  "/MISC/IT and Computing/Networks/048-wifi.svg",
  "/MISC/IT and Computing/Networks/017-cloud-computing.svg",
  "/MISC/IT and Computing/Networks/070-file-2.svg",
  "/MISC/IT and Computing/Networks/029-desktop-1.svg",
  "/MISC/IT and Computing/010-computer.svg",
  "/MISC/IT and Computing/027-motherboard.svg",
  "/MISC/IT and Computing/041-computer.svg",
  "/MISC/IT and Computing/003-cpu.svg",
  "/MISC/IT and Computing/011-bug.svg",
  "/MISC/IT and Computing/020-error 404.svg",
  "/MISC/IT and Computing/037-downloading.svg",
  "/MISC/IT and Computing/047-software.svg",
  "/MISC/IT and Computing/024-browsing.svg",
  "/MISC/IT and Computing/035-security.svg",
  "/MISC/IT and Computing/030-computer.svg",
  "/MISC/IT and Computing/050-binary code.svg",
  "/MISC/IT and Computing/017-laptop.svg",
  "/MISC/IT and Computing/022-coding.svg",
  "/MISC/IT and Computing/015-online store.svg",
  "/MISC/IT and Computing/023-web coding.svg",
  "/MISC/IT and Computing/040-system.svg",
  "/MISC/IT and Computing/013-cd.svg",
  "/MISC/IT and Computing/049-bugs.svg",
  "/MISC/IT and Computing/Hardware/029-pendrive.svg",
  "/MISC/IT and Computing/Hardware/040-server.svg",
  "/MISC/IT and Computing/Hardware/009-circuit.svg",
  "/MISC/IT and Computing/Hardware/018-jack cable.svg",
  "/MISC/IT and Computing/Hardware/022-laptop.svg",
  "/MISC/IT and Computing/Hardware/024-micro sd.svg",
  "/MISC/IT and Computing/Hardware/049-webcam.svg",
  "/MISC/IT and Computing/Hardware/019-joystick.svg",
  "/MISC/IT and Computing/Hardware/021-cable.svg",
  "/MISC/IT and Computing/Hardware/006-cctv.svg",
  "/MISC/IT and Computing/Hardware/045-speakers.svg",
  "/MISC/IT and Computing/Hardware/007-cd drive.svg",
  "/MISC/IT and Computing/Hardware/031-power button.svg",
  "/MISC/IT and Computing/Hardware/027-motherboard.svg",
  "/MISC/IT and Computing/Hardware/026-monitor.svg",
  "/MISC/IT and Computing/Hardware/002-adapter.svg",
  "/MISC/IT and Computing/Hardware/003-battery.svg",
  "/MISC/IT and Computing/Hardware/047-usb.svg",
  "/MISC/IT and Computing/Hardware/035-projector.svg",
  "/MISC/IT and Computing/Hardware/044-sound card.svg",
  "/MISC/IT and Computing/Hardware/036-Ram Memory.svg",
  "/MISC/IT and Computing/Hardware/015-graphic card.svg",
  "/MISC/IT and Computing/Hardware/017-headphone.svg",
  "/MISC/IT and Computing/Hardware/008-chips.svg",
  "/MISC/IT and Computing/Hardware/038-router.svg",
  "/MISC/IT and Computing/Hardware/046-ssd drive.svg",
  "/MISC/IT and Computing/Hardware/043-socket.svg",
  "/MISC/IT and Computing/Hardware/014-graphic tablet.svg",
  "/MISC/IT and Computing/Hardware/016-harddisk.svg",
  "/MISC/IT and Computing/Hardware/004-bluetooth.svg",
  "/MISC/IT and Computing/Hardware/039-scanner.svg",
  "/MISC/IT and Computing/Hardware/011-cpu tower.svg",
  "/MISC/IT and Computing/Hardware/001-accumulator.svg",
  "/MISC/IT and Computing/Hardware/032-power supply.svg",
  "/MISC/IT and Computing/Hardware/048-vga card.svg",
  "/MISC/IT and Computing/Hardware/041-sim card.svg",
  "/MISC/IT and Computing/Hardware/028-personal computer.svg",
  "/MISC/IT and Computing/Hardware/013-fan.svg",
  "/MISC/IT and Computing/Hardware/020-keyboard.svg",
  "/MISC/IT and Computing/Hardware/005-calculator.svg",
  "/MISC/IT and Computing/Hardware/012-ethernet.svg",
  "/MISC/IT and Computing/Hardware/025-modem.svg",
  "/MISC/IT and Computing/Hardware/010-console.svg",
  "/MISC/IT and Computing/Hardware/030-plug.svg",
  "/MISC/IT and Computing/Hardware/034-processors.svg",
  "/MISC/IT and Computing/Hardware/023-memory card.svg",
  "/MISC/IT and Computing/Hardware/037-ribbon cable.svg",
  "/MISC/IT and Computing/Hardware/033-printer.svg",
  "/MISC/IT and Computing/Hardware/042-sitemap.svg",
  "/MISC/IT and Computing/018-computer.svg",
  "/MISC/IT and Computing/016-wifi router.svg",
  "/MISC/IT and Computing/031-database.svg",
  "/MISC/IT and Computing/012-article.svg",
  "/MISC/IT and Computing/043-settings.svg",
  "/MISC/IT and Computing/IoT/006-battery status.svg",
  "/MISC/IT and Computing/IoT/028-stereo.svg",
  "/MISC/IT and Computing/IoT/020-modem.svg",
  "/MISC/IT and Computing/IoT/014-printer.svg",
  "/MISC/IT and Computing/IoT/011-camera.svg",
  "/MISC/IT and Computing/IoT/008-lcd hd.svg",
  "/MISC/IT and Computing/IoT/022-microwave oven.svg",
  "/MISC/IT and Computing/IoT/021-digital alarm clock.svg",
  "/MISC/IT and Computing/IoT/019-smart home.svg",
  "/MISC/IT and Computing/IoT/025-water dispenser.svg",
  "/MISC/IT and Computing/IoT/029-smart lighting.svg",
  "/MISC/IT and Computing/IoT/024-fans.svg",
  "/MISC/IT and Computing/IoT/004-phone call.svg",
  "/MISC/IT and Computing/IoT/003-tap water.svg",
  "/MISC/IT and Computing/IoT/013-usb modem.svg",
  "/MISC/IT and Computing/IoT/023-door lock.svg",
  "/MISC/IT and Computing/IoT/010-smart home.svg",
  "/MISC/IT and Computing/IoT/012-smart lock.svg",
  "/MISC/IT and Computing/IoT/026-phone.svg",
  "/MISC/IT and Computing/IoT/015-remote assistance.svg",
  "/MISC/IT and Computing/IoT/007-smart light.svg",
  "/MISC/IT and Computing/IoT/018-smart watch.svg",
  "/MISC/IT and Computing/IoT/016-mobile.svg",
  "/MISC/IT and Computing/IoT/001-cctv.svg",
  "/MISC/IT and Computing/IoT/017-parabolic antenna.svg",
  "/MISC/IT and Computing/IoT/005-air conditioner.svg",
  "/MISC/IT and Computing/IoT/027-washing machine.svg",
  "/MISC/IT and Computing/IoT/009-smart tv.svg",
  "/MISC/IT and Computing/IoT/002-smartwatch.svg",
  "/MISC/IT and Computing/034-presentation.svg",
  "/MISC/IT and Computing/008-cloud.svg",
  "/MISC/IT and Computing/001-computer.svg",
  "/MISC/IT and Computing/029-floppy disk.svg",
  "/MISC/IT and Computing/004-software.svg",
  "/MISC/IT and Computing/002-computer.svg",
  "/MISC/IT and Computing/007-tablet.svg",
  "/MISC/IT and Computing/026-files.svg",
  "/MISC/IT and Computing/044-laptop.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/018-pet-insurance-1.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/034-life-insurance-5.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/020-fire.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/044-insurance-3.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/017-pet-insurance.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/039-money.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/003-fender-bender.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/033-life-insurance-4.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/012-savings.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/032-life-insurance-3.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/028-earthquake.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Transactions/033-phone-banking-2.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Transactions/021-smartphone-2.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Transactions/034-money-deposit.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Transactions/028-qr-code-1.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Transactions/031-money-exchange.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Transactions/017-bank-account-3.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Transactions/029-qr-code-2.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Transactions/007-smartphone-payment.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Transactions/020-portfolio.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Transactions/019-phone-banking-1.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Transactions/015-bank-account-1.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Transactions/011-borrow.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Transactions/005-credit-card.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Transactions/012-smartphone-payment-1.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Transactions/036-loan.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Transactions/004-receipt.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Transactions/026-financial-information.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Transactions/006-money.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Transactions/024-cash-money.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Transactions/001-bankbook.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Transactions/030-online-shopping.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Transactions/025-bank-1.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Transactions/013-smartphone-1.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Transactions/016-bank-account-2.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Transactions/023-cash.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Transactions/018-phone-banking.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Transactions/009-smartphone.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Transactions/035-online-banking-1.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Transactions/002-atm.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Transactions/022-online-banking.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Transactions/008-banking.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Transactions/027-qr-code.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Transactions/003-bank.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Transactions/010-cloud-banking.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Transactions/014-bank-account.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Transactions/032-money-bag.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/010-life-insurance.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/046-thief.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/029-pet-insurance-2.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/011-travel-insurance.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/009-tow-truck.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/025-leak.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/043-life-insurance-6.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/041-home-insurance-2.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/021-flood.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/016-money-bag.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/040-travel-insurance-1.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/006-home-insurance.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/022-insurance-2.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/038-user.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/001-insurance.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/031-life-insurance-2.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/047-safebox.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/045-umbrella.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/050-mortarboard.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/008-box.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/048-funeral.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/004-insurance-1.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/030-fire-1.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/026-shipping.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/014-smartphone.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/036-laptop.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/023-delivery-truck.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/049-building.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/027-padlock.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/002-briefcase.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/007-car-insurance.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/013-life-insurance-1.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/005-lifesaver.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/044-tag.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/029-internet.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/052-target.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/048-contract.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/013-briefcase.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/041-presentation.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/015-calculator.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/024-contract.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/012-briefcase.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/055-visa.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/030-gold ingot.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/036-money bag.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/005-atm.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/020-agenda.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/028-globe.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/042-presentation.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/038-network.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/050-target.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/045-safebox.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/026-settings.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/003-amex.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/009-bank.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/034-shield.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/001-abacus.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/053-time is money.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/008-auction.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/046-safebox.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/017-calculator.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/022-contact.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/032-hand shake.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/035-key.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/023-contract.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/033-shield.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/027-network.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/004-amex.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/011-bank.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/025-money bag.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/047-search.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/031-gold ingot.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/051-target.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/018-cash.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/010-bank.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/049-strategy.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/006-atm.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/014-calculator.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/039-networking.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/040-presentation.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/054-visa.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/043-ticket.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/021-agenda.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/019-check.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/002-megaphone.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/007-atm.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/016-calculator.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/Business and Finance/037-network.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/042-car-insurance-2.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/035-antivirus.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/037-diamond.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/015-car-insurance-1.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/019-home-insurance-1.svg",
  "/K - FINANCIAL AND INSURANCE ACTIVITIES/024-auction.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/008-athlete.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/035-doctor.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/012-banker.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/027-clown.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/046-footballer.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/033-deliveryman.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/097-veterinarian.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/020-butcher.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/061-musician.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/084-Salesman.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/037-editor.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/022-cashier.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/042-farmer.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/092-tailor.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/073-Politician.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/048-ranger.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/023-nun.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/013-barber.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/015-bellboy.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/054-judge.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/036-doorman.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/060-miner.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/040-entrepreneur.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/016-broker.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/028-coach.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/068-photographer.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/025-chef.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/007-astronaut.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/011-dancer.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/018-Burglar.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/070-plumber.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/002-actor.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/078-programmer.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/006-artist.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/089-speaker.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/094-teacher.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/088-soldier.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/087-shoemaker.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/019-businessman.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/075-priest.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/083-sailor.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/045-flight attendant.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/090-student.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/029-builder.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/082-reporter.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/074-postman.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/067-Pharmacist.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/034-dentist.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/086-secretary.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/044-fisherman.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/072-policeman.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/085-scientist.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/038-electrician.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/079-real estate.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/096-train.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/059-mechanic.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/014-makeup artist.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/017-builder.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/049-gardener.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/041-worker.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/021-carpenter.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/043-fireman.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/039-engineer.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/058-magician.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/003-actress.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/001-accountant.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/057-lunchroom.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/093-taxi driver.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/050-gas station attendant.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/030-craftsman.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/052-housekeeper.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/095-tour guide.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/063-office worker.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/062-nurse.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/047-foreman.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/024-Chauffeur.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/098-waiter.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/004-american football player.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/056-lifeguard.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/091-surgeon.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/081-repairman.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/064-painter.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/080-receptionist.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/076-painter.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/099-waitress.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/077-professor.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/065-paramedic.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/053-human resources.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/031-criminal.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/010-baker.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/069-pilot.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/009-writer.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/055-lawyer.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/066-pastor.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/026-clerk.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/071-poet.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/051-geisha.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/100-watchmaker.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/005-architect.svg",
  "/S - OTHER SERVICE ACTIVITIES/Various Occupations/032-customs.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/024-popcorn.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/006-speaker.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/019-film reel.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/008-radio.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/018-game console.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/027-chess.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/017-poker chips.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/014-unicycle.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/047-slot machine.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/003-movie ticket.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/001-game controller.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/033-dart board.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/031-magic hat.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/015-music equalizer.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/043-shopping bags.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/012-laptop.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/044-spotlight.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/023-television.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/050-billiard.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/028-microphone.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/045-trumpet.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/021-phonograph.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/020-walkman.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/026-video recorder.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/009-projector.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/040-drum.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/005-microphone.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/042-music app.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/036-disco ball.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/039-clown.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/013-music player.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/022-turntable.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/038-confetti.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Creativity/009-compass.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Creativity/005-photo camera.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Creativity/003-brain.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Creativity/033-vector.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Creativity/022-owl.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Creativity/026-presentation.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Creativity/027-report.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Creativity/013-notebook.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Creativity/011-creativity.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Creativity/015-graphic design.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Creativity/020-creative.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Creativity/002-artificial intelligence.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Creativity/008-pantone.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Creativity/014-pyramid.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Creativity/025-paint bucket.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Creativity/031-stationary.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Creativity/004-brainstorm.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Creativity/018-idea.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Creativity/023-layers.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Creativity/017-imagination.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Creativity/030-idea.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Creativity/007-coding.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Creativity/016-idea.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Creativity/034-creative.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Creativity/028-portfolio.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Creativity/032-success.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Creativity/021-creative.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Creativity/029-search.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Creativity/024-motivation.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Creativity/010-creative.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Creativity/035-Watercolor.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Creativity/019-robot.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Creativity/001-cube.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Creativity/006-canvas.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Creativity/012-deadline.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Creativity/036-web design.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/041-piano keyboard.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/030-picnic basket.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/016-cinema.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/029-circus tent.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/035-theater masks.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/002-smart tv.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/golf.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/darts.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/boxing-shorts.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/football-pitch.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/boxing-1.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/eight-ball.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/weight-3.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/torch.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/olympic-games.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/measuring-tape.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/boxing-ring.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/dumbbell.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/jumping-rope.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/volleyball.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/racing.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/baseball-1.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/basketball.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/cycling.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/weight-2.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/chess.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/basketball-1.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/fishing.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/muscle.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/hockey-pitch.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/world-cup.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/shoe-1.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/ping-pong-1.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/cricket.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/weight-1.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/locker.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/basketball-court.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/medal.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/ping-pong.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/karate.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/weight.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/surf.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/kayak.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/roller-skate.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/bowling-1.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/soccer.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/curling.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/bowling.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/yachting.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/skateboard.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/punch.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/hockey.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/strength.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/racing-helmet-1.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/shoe.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/tennis-ball.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/basketball-jersey.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/archery.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/stopwatch.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/treadmill.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/glove.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/punch-1.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/rowing.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/baseball-2.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/golf-1.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/scoreboard.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/american-football-1.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/tennis-court.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/ballet.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/hockey-1.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/football-jersey.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/surf-1.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/steering-wheel.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/racing-helmet.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/boot.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/baseball.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/bottle.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/american-football.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/waterpolo.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/shorts.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/soccer-1.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/yoga-ball.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/podium.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/stopwatch-1.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/goggles.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/badminton.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/lacrosse.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/cup.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/bicycle.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/stationary-bike.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/rugby.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/ice-skating.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/soccer-jersey.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/football-field.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/whistle.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/target.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/tactics.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/boot-1.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/trampoline.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/tennis.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/pool.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/yoga.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/boxing-ring-1.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/referee.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/boxing.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Sports/hiking.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/007-cd player.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/025-carousel.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/037-fireworks.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/004-headphones.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/048-claw machine.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/032-ballet.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/011-poker.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/034-dices.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/013-archery.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/048-thermos.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/032-sleeping bag.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/044-fire lamp.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/036-golf.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/040-duck.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/004-cabin.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/023-tennis.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/017-yacht.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/003-caravan.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/006-compass.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/033-hunting.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/028-ice axe.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/019-seesaw.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/002-bike.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/045-beach.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/026-jumping rope.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/030-leash.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/020-mushrooms.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/016-skiing.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/010-canoe.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/015-skydiving.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/012-rollerblade.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/011-gardening.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/029-swing.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/039-flashlight.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/001-skateboard.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/042-beach volleyball.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/027-kite.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/034-cooking.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/021-frisbee.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/031-guitar.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/041-picture.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/024-picnic.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/047-books.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/050-fishing.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/008-bbq.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/007-camping.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/022-baseball.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/025-ice skate.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/043-marshmallow.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/018-pool.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/014-axe.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/046-matches.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/038-bonfire.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/049-hot air balloon.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/009-pocket knife.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/005-backpack.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/037-bbq.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/Outdoor Activities/035-sandbox.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/049-art gallery.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/010-tablet.svg",
  "/R - ARTS, ENTERTAINMENT AND RECREATION/046-clapperboard.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/027-web.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/005-online banking.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/014-dollar bills.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/023-safety box.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/017-online banking.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/007-bank.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/022-safety box.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/026-smartphone.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/Economy/005-demand.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/Economy/006-economic.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/Economy/020-economic.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/Economy/028-incomes.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/Economy/035-human resources.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/Economy/010-exchange rate.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/Economy/014-economic.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/Economy/018-industry.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/Economy/003-global economy.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/Economy/025-online store.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/Economy/004-statistic.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/Economy/032-population.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/Economy/013-financial.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/Economy/024-value.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/Economy/011-shipping.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/Economy/016-gdp.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/Economy/034-profit.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/Economy/017-innovation.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/Economy/033-productivity.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/Economy/009-entrepreneur.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/Economy/031-Politician.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/Economy/015-go green.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/Economy/019-inflation.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/Economy/029-renewable energy.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/Economy/021-investing.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/Economy/027-measurement.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/Economy/026-excavator.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/Economy/002-review.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/Economy/030-oil rig.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/Economy/001-cycle.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/Economy/008-solar cell.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/Economy/036-supply.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/Economy/007-graduation.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/Economy/023-labor.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/Economy/012-startup.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/Economy/022-investor.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/008-bank.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/009-gold.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/019-bank.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/013-cash.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/021-safety box.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/001-atm.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/016-bank.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/002-bank.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/025-smartphone.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/004-bank.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/015-bank.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/011-analytics.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/012-dollar bills.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/024-piggy bank.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/006-diamond.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/020-bank.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/003-bank.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/018-bank.svg",
  "/U - ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES/010-analytics.svg",
  "/F - CONSTRUCTION/007-judge.svg",
  "/F - CONSTRUCTION/049-bridge.svg",
  "/F - CONSTRUCTION/045-size.svg",
  "/F - CONSTRUCTION/038-light tower.svg",
  "/F - CONSTRUCTION/036-air blower.svg",
  "/F - CONSTRUCTION/002-dump truck.svg",
  "/F - CONSTRUCTION/029-spirit level.svg",
  "/F - CONSTRUCTION/019-electricity.svg",
  "/F - CONSTRUCTION/046-building.svg",
  "/F - CONSTRUCTION/013-floor plan.svg",
  "/F - CONSTRUCTION/001-mixer truck.svg",
  "/F - CONSTRUCTION/021-gas mask.svg",
  "/F - CONSTRUCTION/014-cement.svg",
  "/F - CONSTRUCTION/044-crane.svg",
  "/F - CONSTRUCTION/028-vise.svg",
  "/F - CONSTRUCTION/Civil Engineering/023-project.svg",
  "/F - CONSTRUCTION/Civil Engineering/004-driller.svg",
  "/F - CONSTRUCTION/Civil Engineering/016-wheelbarrow.svg",
  "/F - CONSTRUCTION/Civil Engineering/017-toolbox.svg",
  "/F - CONSTRUCTION/Civil Engineering/011-bridge.svg",
  "/F - CONSTRUCTION/Civil Engineering/009-drilling-1.svg",
  "/F - CONSTRUCTION/Civil Engineering/006-engineer.svg",
  "/F - CONSTRUCTION/Civil Engineering/001-tripod.svg",
  "/F - CONSTRUCTION/Civil Engineering/020-forklift.svg",
  "/F - CONSTRUCTION/Civil Engineering/008-construction.svg",
  "/F - CONSTRUCTION/Civil Engineering/003-drilling.svg",
  "/F - CONSTRUCTION/Civil Engineering/010-shovel.svg",
  "/F - CONSTRUCTION/Civil Engineering/022-construction-1.svg",
  "/F - CONSTRUCTION/Civil Engineering/005-design.svg",
  "/F - CONSTRUCTION/Civil Engineering/007-no-entry.svg",
  "/F - CONSTRUCTION/Civil Engineering/012-process.svg",
  "/F - CONSTRUCTION/Civil Engineering/015-design-1.svg",
  "/F - CONSTRUCTION/Civil Engineering/013-crane.svg",
  "/F - CONSTRUCTION/Civil Engineering/014-engineer-1.svg",
  "/F - CONSTRUCTION/Civil Engineering/019-configuration.svg",
  "/F - CONSTRUCTION/Civil Engineering/021-plan-1.svg",
  "/F - CONSTRUCTION/Civil Engineering/002-plan.svg",
  "/F - CONSTRUCTION/Civil Engineering/024-truck.svg",
  "/F - CONSTRUCTION/Civil Engineering/018-crane-1.svg",
  "/F - CONSTRUCTION/Civil Engineering/025-welding.svg",
  "/F - CONSTRUCTION/041-planning.svg",
  "/F - CONSTRUCTION/006-wallpaper.svg",
  "/F - CONSTRUCTION/043-building.svg",
  "/F - CONSTRUCTION/031-tool box.svg",
  "/F - CONSTRUCTION/011-boom lift.svg",
  "/F - CONSTRUCTION/034-measuring device.svg",
  "/F - CONSTRUCTION/015-tape measure.svg",
  "/F - CONSTRUCTION/026-paint.svg",
  "/F - CONSTRUCTION/050-jackhammer.svg",
  "/F - CONSTRUCTION/016-architect.svg",
  "/F - CONSTRUCTION/003-under construction.svg",
  "/F - CONSTRUCTION/027-worker.svg",
  "/F - CONSTRUCTION/022-scissor lift.svg",
  "/F - CONSTRUCTION/032-floor polisher.svg",
  "/F - CONSTRUCTION/009-bulldozer.svg",
  "/F - CONSTRUCTION/042-mallet.svg",
  "/F - CONSTRUCTION/030-saw.svg",
  "/F - CONSTRUCTION/040-demolition.svg",
  "/F - CONSTRUCTION/035-plumb bob.svg",
  "/F - CONSTRUCTION/008-ladder.svg",
  "/F - CONSTRUCTION/005-forklift.svg",
  "/F - CONSTRUCTION/010-timber.svg",
  "/F - CONSTRUCTION/023-tool belt.svg",
  "/F - CONSTRUCTION/025-grinder.svg",
  "/F - CONSTRUCTION/037-paint.svg",
  "/F - CONSTRUCTION/004-drill.svg",
  "/F - CONSTRUCTION/017-crane.svg",
  "/F - CONSTRUCTION/048-road roller.svg",
  "/F - CONSTRUCTION/018-plumbing.svg",
  "/F - CONSTRUCTION/033-generator.svg",
  "/F - CONSTRUCTION/020-sealant gun.svg",
  "/F - CONSTRUCTION/024-hammer.svg",
  "/F - CONSTRUCTION/012-budget.svg",
  "/F - CONSTRUCTION/047-plate compactors.svg",
  "/F - CONSTRUCTION/039-wrecking ball.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/041-missile.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/086-barrier.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/035-mortar.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/014-tank.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/007-pistol.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/015-gun.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/057-tent.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/029-gun.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/059-flask.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/048-medal.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/051-bottle.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/074-food.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/090-knife.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/096-mine.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/053-satellite.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/050-warehouse.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/052-first aid.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/098-badge.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/089-swords.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/097-warehouse.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/036-medal.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/045-soldier.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/073-Artillery.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/030-bomb.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/100-bunker.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/080-magnifying glass.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/038-box.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/021-medal.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/060-pilot.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/079-bomber.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/044-medal.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/003-gun.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/055-box.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/039-grenade launcher.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/023-hat.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/064-medic.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/063-heliciopter.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/042-flare.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/002-tank.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/010-truck.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/075-gun.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/046-binoculars.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/067-building.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/028-grenade.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/076-dynamite.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/040-plane.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/006-bomb.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/099-ammunition.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/054-boot.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/026-ammo.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/031-medal.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/011-scope.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/043-barbed wire.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/001-helmet.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/082-c4.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/016-grenade.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/062-prosthetic.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/017-bayonet.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/004-drone.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/083-gun.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/034-jeep.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/071-gun.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/013-dog tag.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/025-grenade.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/019-truck.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/077-radio.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/091-shield.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/094-turret.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/061-truck.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/037-submarine.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/058-target.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/081-tower.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/072-plane.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/085-skull.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/070-badge.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/078-badge.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/032-ship.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/009-explosion.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/033-backpack.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/008-bullet.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/087-bomb.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/084-walkie talkie.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/020-bomb.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/095-jail.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/056-grave.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/024-jet.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/066-flag.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/022-vest.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/088-bombs.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/005-knife.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/065-arm.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/012-beret.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/047-mask.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/027-jeep.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/068-helicopter.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/049-sonar.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/069-dog.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/018-gun.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/093-shovel.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Military and Defence/092-torch.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/027-bureaucracy.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/043-censure.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/039-monetary policy.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/018-proportional.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/012-senate.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/013-executive.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/030-judicial.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/046-federal.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/037-coalition.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/011-grassroots.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/024-electoral.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/020-globalization.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/041-electoral.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/005-public opinion.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/025-national security agency.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/023-campaign.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/007-budget.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/036-alliance.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/034-system.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/001-separation.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/016-corruption.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/003-bill of rights.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/002-united nations.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/042-policy.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/014-deficit.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/009-election.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/047-activism.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/049-revolution.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/045-political science.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/015-constitution.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/029-social security.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/040-foreign.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/044-single.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/010-human rights.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/026-public service.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/048-civil rights.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/022-sanction.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/033-review.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/028-control.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/004-international relations.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/031-non governmental organization.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/006-diplomacy.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/019-reform.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/017-executives.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/038-bipartisan.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/008-civil liberties.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/035-democracy.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/032-republic.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/050-interest.svg",
  "/O - PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY/Global Politics/021-humanitarian help.svg",
  "/P - EDUCATION/2231604-education/043-exam.svg",
  "/P - EDUCATION/2231604-education/018-studying.svg",
  "/P - EDUCATION/2231604-education/015-studying.svg",
  "/P - EDUCATION/2231604-education/026-book.svg",
  "/P - EDUCATION/2231604-education/014-blackboard.svg",
  "/P - EDUCATION/2231604-education/001-graduated.svg",
  "/P - EDUCATION/2231604-education/051-maths.svg",
  "/P - EDUCATION/2231604-education/033-abacus.svg",
  "/P - EDUCATION/2231604-education/003-highlighter.svg",
  "/P - EDUCATION/2231604-education/059-language.svg",
  "/P - EDUCATION/2231604-education/045-owl.svg",
  "/P - EDUCATION/2231604-education/057-abacus.svg",
  "/P - EDUCATION/2231604-education/009-ebook.svg",
  "/P - EDUCATION/2231604-education/058-degree.svg",
  "/P - EDUCATION/2231604-education/002-algebra.svg",
  "/P - EDUCATION/2231604-education/024-online learning.svg",
  "/P - EDUCATION/2231604-education/020-library.svg",
  "/P - EDUCATION/2231604-education/046-degree.svg",
  "/P - EDUCATION/2231604-education/006-books.svg",
  "/P - EDUCATION/2231604-education/021-online learning.svg",
  "/P - EDUCATION/2231604-education/016-maths.svg",
  "/P - EDUCATION/2231604-education/036-book.svg",
  "/P - EDUCATION/2231604-education/029-compass.svg",
  "/P - EDUCATION/2231604-education/013-sharpener.svg",
  "/P - EDUCATION/2231604-education/048-idea.svg",
  "/P - EDUCATION/2231604-education/022-teacher.svg",
  "/P - EDUCATION/2231604-education/023-teacher.svg",
  "/P - EDUCATION/2231604-education/025-books.svg",
  "/P - EDUCATION/2231604-education/005-book.svg",
  "/P - EDUCATION/2231604-education/017-online course.svg",
  "/P - EDUCATION/2231604-education/038-search.svg",
  "/P - EDUCATION/2231604-education/050-translator.svg",
  "/P - EDUCATION/2231604-education/049-trip.svg",
  "/P - EDUCATION/2231604-education/044-exam.svg",
  "/P - EDUCATION/2231604-education/004-sketch.svg",
  "/P - EDUCATION/2231604-education/037-test.svg",
  "/P - EDUCATION/2231604-education/053-translator.svg",
  "/P - EDUCATION/2231604-education/052-maths.svg",
  "/P - EDUCATION/2231604-education/039-book.svg",
  "/P - EDUCATION/2231604-education/027-calculator.svg",
  "/P - EDUCATION/2231604-education/011-online education.svg",
  "/P - EDUCATION/2231604-education/032-school bell.svg",
  "/P - EDUCATION/2231604-education/031-school.svg",
  "/P - EDUCATION/2231604-education/041-idea.svg",
  "/P - EDUCATION/2231604-education/030-school.svg",
  "/P - EDUCATION/2231604-education/019-graduated.svg",
  "/P - EDUCATION/2231604-education/054-ebook.svg",
  "/P - EDUCATION/2231604-education/028-audio book.svg",
  "/P - EDUCATION/2231604-education/008-physics.svg",
  "/P - EDUCATION/2231604-education/060-student.svg",
  "/P - EDUCATION/2231604-education/010-design.svg",
  "/P - EDUCATION/2231604-education/035-agenda.svg",
  "/P - EDUCATION/2231604-education/034-cutting.svg",
  "/P - EDUCATION/2231604-education/007-podcast.svg",
  "/P - EDUCATION/2231604-education/012-book.svg",
  "/P - EDUCATION/2231604-education/040-lunch.svg",
  "/P - EDUCATION/2231604-education/042-testing.svg",
  "/P - EDUCATION/2231604-education/047-student.svg",
  "/P - EDUCATION/2231604-education/055-maths.svg",
  "/P - EDUCATION/2231604-education/056-audiobook.svg",
  "/C - MANUFACTURING/050-conveyor.svg",
  "/C - MANUFACTURING/042-pressure gauge.svg",
  "/C - MANUFACTURING/036-employee.svg",
  "/C - MANUFACTURING/002-pallet.svg",
  "/C - MANUFACTURING/005-factory.svg",
  "/C - MANUFACTURING/014-oil tank.svg",
  "/C - MANUFACTURING/016-wrench.svg",
  "/C - MANUFACTURING/032-conveyor.svg",
  "/C - MANUFACTURING/011-idea.svg",
  "/C - MANUFACTURING/037-foreman.svg",
  "/C - MANUFACTURING/044-container.svg",
  "/C - MANUFACTURING/019-radioactive.svg",
  "/C - MANUFACTURING/034-bottle.svg",
  "/C - MANUFACTURING/035-robotic arm.svg",
  "/C - MANUFACTURING/021-cutting.svg",
  "/C - MANUFACTURING/007-plan.svg",
  "/C - MANUFACTURING/049-computer.svg",
  "/C - MANUFACTURING/012-toolbox.svg",
  "/C - MANUFACTURING/027-trolley.svg",
  "/C - MANUFACTURING/004-plan.svg",
  "/C - MANUFACTURING/026-shipping truck.svg",
  "/C - MANUFACTURING/003-calculator.svg",
  "/C - MANUFACTURING/008-checklist.svg",
  "/C - MANUFACTURING/025-cargo.svg",
  "/C - MANUFACTURING/045-pallet.svg",
  "/C - MANUFACTURING/009-check list.svg",
  "/C - MANUFACTURING/030-freight wagon.svg",
  "/C - MANUFACTURING/046-worker.svg",
  "/C - MANUFACTURING/043-hook.svg",
  "/C - MANUFACTURING/022-conveyor.svg",
  "/C - MANUFACTURING/024-saw machine.svg",
  "/C - MANUFACTURING/018-spray gun.svg",
  "/C - MANUFACTURING/017-weld.svg",
  "/C - MANUFACTURING/039-green factory.svg",
  "/C - MANUFACTURING/048-laser.svg",
  "/C - MANUFACTURING/010-warehouse.svg",
  "/C - MANUFACTURING/020-drill.svg",
  "/C - MANUFACTURING/015-bolt.svg",
  "/C - MANUFACTURING/038-architect.svg",
  "/C - MANUFACTURING/033-factory machine.svg",
  "/C - MANUFACTURING/013-electricity.svg",
  "/C - MANUFACTURING/040-car manufacturing.svg",
  "/C - MANUFACTURING/041-truck.svg",
  "/C - MANUFACTURING/001-tank.svg",
  "/C - MANUFACTURING/006-tools.svg",
  "/C - MANUFACTURING/023-forklift.svg",
  "/C - MANUFACTURING/047-water machine.svg",
  "/C - MANUFACTURING/031-conveyor.svg",
  "/C - MANUFACTURING/028-car manufacturing.svg",
  "/C - MANUFACTURING/029-trolley.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/042-gauge.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/007-eco fuel.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/040-forest.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/017-flask.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/030-rain.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/010-wind turbine.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/041-socket.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/023-co2.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/028-voltmeter.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/046-recycle bin.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/049-light bulb.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/015-magnet.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/009-battery.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/048-accumulator.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/002-hydro power.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/033-coal.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/032-plug.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/043-mining industry.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/050-green house.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/022-biogas.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/024-sprout.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/014-plant.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/026-windsock.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/008-energy.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/021-tree.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/003-green energy.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/044-research.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/016-ecology.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/035-gas.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/012-recycle.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/005-nuclear energy.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/020-dam.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/027-manure.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/011-renewable.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/047-gas station.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/019-sun.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/013-earth.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/031-storm.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/018-placeholder.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/004-wind energy.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/037-oil.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/038-oil.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/025-factory.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/001-solar energy.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/045-diploma.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/006-electrical energy.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/036-electric tower.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/039-balance.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/029-light bulb.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Renewable Energy/034-atom.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Gas/009-oiler.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Gas/022-oil pipeline.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Gas/019-oil price.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Gas/017-contract.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Gas/005-biofuel.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Gas/011-oil barrel.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Gas/021-fracking.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Gas/006-pipeline.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Gas/008-oil free.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Gas/001-pressure.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Gas/026-oil barrel.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Gas/010-oil price.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Gas/043-valve.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Gas/027-global.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Gas/030-oil.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Gas/024-gas.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Gas/015-pipe.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Gas/029-Oil industry.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Gas/002-oil barrel.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Gas/025-oil.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Gas/024-tank.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Gas/028-oil price.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Gas/020-valve.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Gas/003-oil.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Gas/018-oil tank.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Gas/007-fuel.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Gas/016-coal.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Gas/023-oil rig.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Gas/004-gas.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Gas/012-oil spill.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Gas/013-gas pipe.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Gas/014-laboratory.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/094-tools-2.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/062-smartphone.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/033-tools.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/017-electricity-4.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/053-light-bulb-7.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/011-electricity-2.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/032-electrician.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/095-tools-3.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/083-light-switch-1.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/001-electric-tower.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/064-electricity-10.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/091-light-switch-2.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/054-light-bulb-8.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/027-cpu.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/067-bill.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/052-light-bulb-6.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/008-driller-1.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/014-plugs.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/080-electricity-13.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/098-light-bulb-10.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/036-plug-1.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/055-light-bulb-9.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/009-electricity.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/082-circuit-5.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/051-plug-2.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/084-tag.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/070-power-button.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/056-electricity-9.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/069-fuse-box-1.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/061-cpu-1.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/068-agenda.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/044-electricity-7.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/039-light-bulb-3.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/048-fuse-box.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/077-socket.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/057-maintenance.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/100-cable-reel-1.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/034-toolbox.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/046-electricity-8.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/035-electrician-1.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/018-electrical-circuit-1.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/050-light-bulb-5.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/026-battery-1.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/089-electricity-14.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/090-battery-3.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/059-maintenance-2.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/075-house-1.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/020-medal.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/038-circuit-3.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/005-circuit-1.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/045-truck.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/031-license.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/072-circuit-4.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/015-wire.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/063-pliers.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/040-house.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/043-electricity-6.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/028-plug.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/010-electricity-1.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/021-light-bulb.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/024-power-plant.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/092-toolbox-1.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/003-checklist.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/099-cable-reel.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/029-light-bulb-1.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/066-battery-2.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/025-electricity-5.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/097-electricity-15.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/007-driller.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/073-electricity-12.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/058-maintenance-1.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/065-electricity-11.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/037-light-bulb-2.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/088-spanner-2.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/079-socket-2.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/086-spanner.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/071-plug-3.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/002-battery.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/085-settings.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/087-spanner-1.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/023-report.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/016-electrical-circuit.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/004-circuit.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/019-id-card.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/022-pin.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/081-power-plant-1.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/041-electric-meter.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/012-electricity-3.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/049-electric-meter-1.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/096-flashlight.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/042-light-switch.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/047-light-bulb-4.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/060-electric-meter-2.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/078-socket-1.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/030-chat.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/093-tools-1.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/074-plug-4.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/076-power.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/006-circuit-2.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Electricity/013-switch.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/012-air-conditioner-30.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/017-technician.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/002-air-conditioner-37.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/019-air-conditioner-25.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/027-air-conditioner-22.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/035-air-conditioner-14.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/042-air-conditioner-7.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/028-air-conditioner-21.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/026-remote.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/023-condenser.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/043-air-conditioner-6.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/024-cooling.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/020-air-conditioner-24.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/013-air-conditioner-29.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/014-air-conditioner-28.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/049-air-conditioner-1.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/031-air-conditioner-18.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/032-air-conditioner-17.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/036-air-conditioner-13.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/045-air-conditioner-4.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/030-air-conditioner-19.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/011-air-conditioner-31.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/006-air-conditioner-36.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/038-air-conditioner-11.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/046-air-conditioner-3.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/047-air-cooler.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/041-air-conditioner-8.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/033-air-conditioner-16.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/039-air-conditioner-10.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/022-air-conditioner-23.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/009-air-conditioner-33.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/007-air-conditioner-35.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/048-air-conditioner-2.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/016-fan.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/040-air-conditioner-9.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/018-air-conditioner-26.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/044-air-conditioner-5.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/008-air-conditioner-34.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/003-turbine.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/004-car.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/001-hood.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/010-air-conditioner-32.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/005-house.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/025-chiller.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/021-ventilator.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/034-air-conditioner-15.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/037-air-conditioner-12.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/015-air-conditioner-27.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/050-air-conditioner.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Air Conditioning/029-air-conditioner-20.svg",
  "/D - ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY/Steam/steam-power.svg",
  "/H - TRANSPORTATION AND STORAGE/005-scale.svg",
  "/H - TRANSPORTATION AND STORAGE/025-container.svg",
  "/H - TRANSPORTATION AND STORAGE/048-boxes.svg",
  "/H - TRANSPORTATION AND STORAGE/Trucks/015-truck.svg",
  "/H - TRANSPORTATION AND STORAGE/Trucks/020-tractor.svg",
  "/H - TRANSPORTATION AND STORAGE/Trucks/011-truck.svg",
  "/H - TRANSPORTATION AND STORAGE/Trucks/023-truck.svg",
  "/H - TRANSPORTATION AND STORAGE/Trucks/025-water tank truck.svg",
  "/H - TRANSPORTATION AND STORAGE/Trucks/014-snow plow.svg",
  "/H - TRANSPORTATION AND STORAGE/Trucks/013-truck.svg",
  "/H - TRANSPORTATION AND STORAGE/Trucks/005-dump truck.svg",
  "/H - TRANSPORTATION AND STORAGE/Trucks/022-truck.svg",
  "/H - TRANSPORTATION AND STORAGE/Trucks/006-fire truck.svg",
  "/H - TRANSPORTATION AND STORAGE/Trucks/010-garbage truck.svg",
  "/H - TRANSPORTATION AND STORAGE/Trucks/016-tanker.svg",
  "/H - TRANSPORTATION AND STORAGE/Trucks/021-truck.svg",
  "/H - TRANSPORTATION AND STORAGE/Trucks/012-pickup truck.svg",
  "/H - TRANSPORTATION AND STORAGE/Trucks/003-cement mixer truck.svg",
  "/H - TRANSPORTATION AND STORAGE/Trucks/008-food truck.svg",
  "/H - TRANSPORTATION AND STORAGE/Trucks/004-crane truck.svg",
  "/H - TRANSPORTATION AND STORAGE/Trucks/019-tow truck.svg",
  "/H - TRANSPORTATION AND STORAGE/Trucks/002-cargo truck.svg",
  "/H - TRANSPORTATION AND STORAGE/Trucks/009-forklift.svg",
  "/H - TRANSPORTATION AND STORAGE/Trucks/007-flatbed.svg",
  "/H - TRANSPORTATION AND STORAGE/Trucks/024-truck.svg",
  "/H - TRANSPORTATION AND STORAGE/Trucks/001-bucket lift.svg",
  "/H - TRANSPORTATION AND STORAGE/Trucks/018-tow truck.svg",
  "/H - TRANSPORTATION AND STORAGE/Trucks/017-towing truck.svg",
  "/H - TRANSPORTATION AND STORAGE/002-trolley.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/014-parking meter.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/003-mobile app.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/027-underground.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/022-traffic lights.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/049-van.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/039-bus.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/021-luggage cart.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/012-rickshaw.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/046-signpost.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/037-scooter.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/008-bus ticket.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/018-directional sign.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/042-zeppelin.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/050-electric scooter.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/034-forklift.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/015-bus.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/032-tram.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/040-map.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/038-trolley bus.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/041-dump truck.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/044-airplane.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/036-motorcycle.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/028-double decker bus.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/019-waiting room.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/013-turnstile.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/006-disabled sign.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/001-helicopter.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/031-cable car.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/026-ambulance.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/007-delivery van.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/043-skate board.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/033-truck.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/020-gateway.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/002-escalator.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/045-ticket window.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/024-train.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/035-rowboat.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/004-bicycle.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/011-ship.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/048-snowmobile.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/005-traveler.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/016-bus station.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/023-ticket machine.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/047-driver.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/025-stop.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/009-online booking.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/030-ticket collector.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/017-subway.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/029-crane truck.svg",
  "/H - TRANSPORTATION AND STORAGE/Public Transport/010-taxi.svg",
  "/H - TRANSPORTATION AND STORAGE/018-warehouse.svg",
  "/H - TRANSPORTATION AND STORAGE/041-conveyor belt.svg",
];

export default assetKinds;

export const loadAssetKindOptions = (search, prevOptions) => {
  const filtered = assetKinds.filter((a) =>
    a.split("/").pop()?.toLowerCase().includes(search.toLowerCase())
  );
  return {
    options: filtered
      .slice(prevOptions.length, prevOptions.length + 10)
      .map((a) => ({
        label: a.split("/").pop()?.split(".")[0].replace("-", " ") || a,
        value: a,
      })),
    hasMore: filtered.length > prevOptions.length + 10,
  };
};

export const formatAssetKindOptionLabel = (o) => {
  return (
    <div className="d-flex align-items-center gap-2">
      <AssetsIcon assetKind={o.value} />
      {o.label}
    </div>
  );
};

export const getAssetKindValueLabels = (values) => {
  return (
    values &&
    values.map((value) => ({
      label: value?.split("/").pop()?.split(".")[0].replace("-", " ") || value,
      value: value,
    }))
  );
};
